import React, { ReactNode } from 'react'

import { AnimatePresence, motion } from 'framer-motion'

import { TRANSITION } from 'Constants/Animations'

type Props = {
  children?: ReactNode
  isOpen?: boolean
}

function Accordion({ children, isOpen }: Props) {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          animate="open"
          exit="collapsed"
          initial="collapsed"
          key="content"
          style={{ overflow: 'hidden' }}
          transition={TRANSITION.DEFAULT}
          variants={{
            open: { height: 'auto', opacity: 1 },
            collapsed: { height: 0, opacity: 0 },
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Accordion
